import { Select, Button, optionsToComponents } from '..';
import { i18n } from '../../i18n';

interface SelectProps {
  label: string;
  options: Array<any>;
  value?: any;
  onChange?: (e: any) => void;
  withoutEmptyValue?: boolean;
  selectedAreasEqaul?: { key?: string; keys: Array<string> };
}

export const TableFilterSelect: React.FC<SelectProps> = ({
  label,
  options,
  value = 'All',
  onChange,
  withoutEmptyValue,
  ...props
}: SelectProps) => {
  return (
    <Select
      options={
        !withoutEmptyValue ? [{ label: i18n.t('button.all'), value: 'All' }, ...options] : options
      }
      label={label}
      value={value}
      onChange={onChange}
    >
      {!withoutEmptyValue && (
        <Button
          size={'medium'}
          data-color={'dropdown-option'}
          data-aria-selected={value === 'All'}
          value={'All'}
        >
          {i18n.t('button.all')}
        </Button>
      )}
      {optionsToComponents(options, { ...props, value })}
    </Select>
  );
};
